import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Modal from 'react-modal'; // Import react-modal

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './displayRealWedding.css'; // Your existing CSS
import axiosInstance from '../../../API/axiosInstance';

// Set the root element for the modal for accessibility
Modal.setAppElement('#root');

const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
};

const RealWeddings = () => {
    const [weddings, setWeddings] = useState([]);
    const [selectedWedding, setSelectedWedding] = useState(null); // This will hold the data for the modal

    useEffect(() => {
        axiosInstance.get("/api/real-weddings/all")
            .then(res => {
                // THIS IS THE MOST IMPORTANT DEBUGGING STEP
                console.log("API Response Data:", res.data);

                setWeddings(res.data);
            })
            .catch(err => {
                console.error("Error fetching weddings:", err); // Also log errors clearly
            });
    }, []);

    // Function to open the modal
    const openModal = (wedding) => {
        setSelectedWedding(wedding);
    };

    // Function to close the modal
    const closeModal = () => {
        setSelectedWedding(null);
    };

    // Settings for the main slider showing wedding cards
    const mainSliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, slidesToScroll: 1 }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }
        ]
    };

    // Settings for the image gallery slider inside the modal
    const modalSliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true, // For a nice cross-fade effect
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options);
    };

    return (
        <section className="real-weddings-section">
            <h2 className="section-title mb-3">Real Wedding Stories</h2>

            {/* Check if the weddings array is not empty */}
            {weddings && weddings.length > 0 ? (
                // If there are weddings, render the Slider
                <Slider {...mainSliderSettings}>
                    {weddings.map((wedding) => (
                        <div key={wedding?._id?.$oid} onClick={() => openModal(wedding)}>
                            <div className="wedding-card">
                                <img
                                    src={wedding.fileUrls[0]}
                                    alt={wedding.title}
                                    className="wedding-image"
                                />
                                <div className="wedding-card-content">
                                    <h3 className="couple-names">{wedding.couples_name}</h3>
                                    <p className="wedding-description">{wedding.title}</p>
                                    <p className="wedding-date">{formatDate(wedding.createdAt.$date)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            ) : (
                // If there are no weddings, render this centered message
                <div className="no-weddings-container">
                    <p className="no-weddings-text">No real wedding stories to show yet.</p>
                </div>
            )}

            {/* Modal for Displaying Wedding Image Gallery (this part remains the same) */}
            {selectedWedding && (
                <Modal
                    isOpen={!!selectedWedding}
                    onRequestClose={closeModal}
                    contentLabel="Wedding Image Gallery"
                    className="wedding-modal"
                    overlayClassName="wedding-modal-overlay"
                >
                    <button className="close-modal-btn" onClick={closeModal}>&times;</button>
                    <h2 className="modal-title">{selectedWedding.couples_name}</h2>
                    <p className="modal-subtitle">{selectedWedding.title}</p>

                    <div className="modal-slider-container">
                        <Slider {...modalSliderSettings}>
                            {selectedWedding.fileUrls.map((url, index) => (
                                <div key={index}>
                                    <img src={url} alt={`${selectedWedding.title} - Image ${index + 1}`} className="modal-image" />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </Modal>
            )}
        </section>
    );
};

export default RealWeddings;